import App from './App.svelte';

const app = new App({
	target: document.querySelector("#app"),
	props: {}
});

export default app;